module.exports = __webpack_public_path__ + "static/img/kjdy06.33c0ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy06.jpg
// module id = 1419
// module chunks = 0